import { ValidationErrors } from "../redux/slices/formValidationSlice";
import type { initialState as FormData } from "../redux/slices/allSelectedDataSlice";

// Full validation for Submit to Accenture
export const validateForm = (formData: FormData): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate investment
  if (!formData.investmentId || !formData.investmentId) {
    errors.investment = "Investment is required";
  }

  // Validate property
  if (!formData.propertyName) {
    errors.property = "Property is required";
  }

  // Validate property manager
  if (!formData.propertyManager || !formData.propertyManager.emailId) {
    errors.propertyManager = "Property manager is required";
  }

  // Validate secondary property manager
  if (!formData.secondaryPropertyManager || !formData.secondaryPropertyManager.emailId) {
    errors.secondaryPropertyManager = "Secondary property manager is required";
  }

  // Validate tenant name
  if (!formData.tenantName) {
    errors.tenantName = "Tenant name is required";
  }

  // Validate unit number
  if (!formData.unitNumber) {
    errors.unitNumber = "Unit number is required";
  }

  // Validate unit square footage
  if (!formData.unitSquareFootage) {
    errors.unitSqrFootage = "Unit square footage is required";
  } 

  // Validate standard tenant
  if (!formData || !formData.standardTenantName) {
    errors.standardTenants = "Standard tenant is required";
  }

  // Validate dates
  if (!formData.leaseCommencement) {
    errors.leaseCommencement = "Lease commencement date is required";
  }

  if (!formData.rentCommencement) {
    errors.rentCommencement = "Rent commencement date is required";
  }

  if (!formData.expiration) {
    errors.expiration = "Expiration date is required";
  }

  if (!formData.nuveenSigningDate) {
    errors.leaseSignedByNuveen = "Lease signed by Nuveen date is required";
  }

  // Validate supporting data comment
  if (!formData.comments) {
    errors.SupportingDataComment = "Supporting data comment is required";
  }

  // Validate file uploads
  if (!formData.fileName) {
    errors.fileUrlList = "At least one file must be uploaded";
  }

  return errors;
};

// Minimum validation for Save button
export const validateMinimumFields = (formData: FormData): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate investment
  if (!formData.investmentId || !formData.investmentId) {
    errors.investment = "Investment is required";
  }

  // Validate property
  if (!formData.propertyName) {
    errors.property = "Property is required";
  }

  // Validate property manager
  if (!formData.propertyManager || !formData.propertyManager.emailId) {
    errors.propertyManager = "Property manager is required";
  }

  return errors;
};

// Validation for Pending Activation status
export const validatePendingActivation = (formData: FormData): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate tenant ID
  if (!formData.tenantId) {
    errors.tenantId = "Tenant ID is required for activation";
  }

  // Validate lease activated date
  if (!formData.leaseActivatedDate) {
    errors.leaseActivatedDate = "Lease activated date is required for activation";
  }

  return errors;
};

// validation for activate lease
export const validateActivateLease = (formData: FormData): ValidationErrors => {
  const errors: ValidationErrors = {};

  if (!formData.subjectToSLR) {
    errors.subjectToSLR = "Subject To SLR is required";
  }
  if (!formData.abstractStatus) {
    errors.abstractStatus = "Abstract Status is required";
  }
  if (!formData.teamMemberId) {
    errors.teamMemberId = "Accenture Team Member Id is required";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.teamMemberId)) {
    errors.teamMemberId = "Accenture Team Member Id must be a valid email address";
  }

  return errors;
};

// Helper function to check if the form has any validation errors
export const hasValidationErrors = (errors: ValidationErrors): boolean => {
  return Object.keys(errors).length > 0;
};
